import { h } from 'vue';
import { Button as AButton } from 'ant-design-vue/es/components';
import { CloseOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { KpiNamePopover } from '@/share/components';

// 父级指标表格列渲染函数生成器
export const useParentNodeRender = ({ editable, col, onAction }) => {
    const handleAction = (action, id, level) => {
        !!onAction && onAction(action, id, level);
    };
    if (!editable) {
        return ({ text }) => {
            return text;
        };
    }
    return ({ text, record }) => {
        const { parents = [] } = record || {};
        const data = parents[col] || {};
        const { id, level, type, parentId } = data || {};

        const handleAdd = () => {
            handleAction('add', parentId, level);
        };

        const handleEdit = () => {
            handleAction('edit', id, level);
        };
        const handleRemove = () => {
            handleAction('remove', id, level);
        };
        const handleAddSub = () => {
            handleAction('add', id, level + 1);
        };

        if (type === 'action') {
            return h(AButton, {
                type: 'link',
                onClick: handleAdd,
            }, {
                default: () => '添加',
                icon: h(EditOutlined),
            });
        } else if (type === 'empty') {
            return '';
        }

        if (col === 0) {
            return h(KpiNamePopover, {
                editMode: true,
                label: text,
                popover: true,
                onEdit: handleEdit,
                onRemove: handleRemove,
                actions: [
                    {
                        title: '编辑',
                        icon: h(EditOutlined),
                        action: handleEdit,
                    },
                    {
                        title: '添加下级',
                        icon: h(PlusOutlined),
                        action: handleAddSub,
                    },
                ],
            });
        }
        return h(KpiNamePopover, {
            editMode: true,
            label: text,
            onEdit: handleEdit,
            onRemove: handleRemove,
            actions: [
                {
                    title: '编辑',
                    icon: h(EditOutlined),
                    action: handleEdit,
                },
                {
                    title: '添加下级',
                    icon: h(PlusOutlined),
                    action: handleAddSub,
                },
                {
                    title: '删除',
                    danger: true,
                    icon: h(CloseOutlined),
                    action: handleRemove,
                },
            ],
        });
    };
};

// 叶节点指标项表格列渲染函数生成器
export const useLeafNodeRender = ({ editable, onAction }) => {
    if (!editable) {
        return ({ text }) => {
            return text;
        };
    }
    // 编辑模式
    return ({ text, record }) => {
        const handleAction = (action, id, level) => {
            !!onAction && onAction(action, id, level);
        };
        const { id, level, parentId, type } = record || {};

        const handleAdd = () => {
            handleAction('add', parentId, level);
        };

        const handleEdit = () => {
            handleAction('edit', id, level);
        };

        const handleRemove = () => {
            handleAction('remove', id, level);
        };

        if (type === 'action') {
            return h(AButton, {
                type: 'link',
                onClick: handleAdd,
            }, {
                default: () => '添加指标项',
                icon: h(PlusOutlined),
            });
        } else if (type === 'empty') {
            return '';
        }
        return h(KpiNamePopover, {
            editMode: true,
            label: text,
            popover: true,
            onEdit: handleEdit,
            onRemove: handleRemove,
            actions: [
                {
                    title: '编辑',
                    icon: h(EditOutlined),
                    action: handleEdit,
                },
                {
                    title: '删除',
                    danger: true,
                    icon: h(CloseOutlined),
                    action: handleRemove,
                },
            ],
        });
    };
};

/**
 * 绩效指标值表格列渲染函数
 * @param text 当前值的文件值
 * @param record 当前行数据
 * @returns {string}
 */
export const kpiValueColumnRender = ({ text, record }) => {
    const { data = {} } = record || {};
    const { compareMode = 0, value = 0, nValue = '', unit = '' } = data || {};
    const compareText = [ '未设置', '不使用', '非量化', '=', '!=', '>', '>=', '<', '<=' ][compareMode];
    if (compareMode === 0) {
        return '';
    }
    if (compareMode === 1) {
        return '不使用';
    }
    if (compareMode === 2) {
        return nValue;
    }
    return `${compareText} ${value} ${unit}`;
};
